export default {
    phone: function (val) {
        if (!/^1\d{10}$/.test(val)) {
            return true
        }
        return false
    },
    // 验证汉字个数
    getByteLen (val) {
        var len = 0
        for (var i = 0; i < val.length; i++) {
            var a = val.charAt(i)
            if (a.match(/[^\x00-\xff]/ig) != null) {
                len += 2
            } else {
                len += 1
            }
        }
        return len
    },
    // 保留两位小数
    toDecimal2 (val) {
        var reg = /^[1-9](\d+)(\.\d{1,2})$/
        if (!reg.test(val)) {
            return true
        }
        return false
    },
    getUrlKey () {
        const url = window.location.href
        var theRequest = {}
        if (url.indexOf('?') !== -1) {
            var str = url.split('?')[1]
            str = str.split('&')
            for (var i = 0; i < str.length; i++) {
                theRequest[str[i].split('=')[0]] = unescape(str[i].split('=')[1])
            }
        }
        return theRequest
    }
}
